// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
  .form-container {
    background-color: white;
    border-radius: 10px;
    padding: 30px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 650px;
    justify-content: center;
    align-items: center;
    align-content: center;
  } */
  /* .password-container{
    position: relative;
  } */
  
  /* .admin-header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }
   */
  /* .add-user-btn {
    background-color: #007bff;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
   */
  /* .add-user-btn:hover {
    background-color: #0056b3;
  } */
/*   
  .password-toggle-btn {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    cursor: pointer;
    color: #b1aeae;
  } */
  /* .error-message{
    color: red;
    font-size: 12px;
    position: absolute;
  } */
  
  /* ::placeholder{
    color: #d1d1d1;
  } */
  
  /* .form-container h2 {
    text-align: center;
    margin-bottom: 20px;
  } */
/*   
  .form-group {
    margin-bottom: 15px;
    display: inline-block;
  } */
  
  /* .form-group label {
    display: block;
    margin-bottom: 5px;
    color: #a4a3a3;
    font-weight: 400;
  } */
  
  /* .form-group input {
    width: 98%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 14px;
  } */
  
  /* .form-group input:focus {
    border-color: #ffa500;
    outline: none;
  } */
  /* .form-group textarea:focus {
    border-color: #ffa500;
    outline: none;
  } */
  /* textarea{
    width: 100%;
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  } */
  
  /* Hide spinner arrows in Firefox */
  /* input[type="number"] {
    --moz-appearance: textfield;
  } */
  /* .submit-btn {
    width: 100%;
    padding: 10px;
    background-color: #28a745;
    border: none;
    border-radius: 5px;
    color: white;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
  }
  .addition{
    width: 100%;
  }
  .submit-btn:hover {
    background-color: #218838;
  }
   */
  
  
  
  /* admin */
  /* .admin-dashboard {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  .admin-main {
    display: flex;
    flex: 1;
  } */
  
  /* .admin-sidebar {
    width: 250px;
    background-color: #b1aeae;
    padding: 1rem;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  }
   */
  /* .admin-sidebar ul {
    list-style-type: none;
    padding: 0;
  }
  
  .admin-sidebar ul li {
    margin-bottom: 1rem;
    cursor: pointer;
    font-weight: bold;
  } */
  
  /* .admin-table-section {
    flex: 1;
    padding: 2rem;
    overflow-x: auto;
  }
  
  .admin-table-section h2 {
    margin-bottom: 1.5rem;
  }
  
  .admin-table {
    width: 100%;
    border-collapse: collapse;
  }
   */
    /* .admin-table th, .admin-table td {
      padding: 12px 15px;
      border: 1px solid #ddd;
      text-align: left;
    }
    
    .admin-table th {
      background-color: #b1aeae;
      color: #fff;
    }
    
    .admin-table tr:nth-child(even) {
      background-color: #f8f9fa;
    }
    */`, "",{"version":3,"sources":["webpack://./src/components/CRUD/add/addUser.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;KAWK;EACH;;KAEG;;EAEH;;;;;IAKE;EACF;;;;;;;;IAQE;EACF;;KAEG;AACL;;;;;;;;;;KAUK;EACH;;;;KAIG;;EAEH;;KAEG;;EAEH;;;KAGG;AACL;;;;KAIK;;EAEH;;;;;KAKG;;EAEH;;;;;;KAMG;;EAEH;;;KAGG;EACH;;;KAGG;EACH;;;;;;;KAOG;;EAEH,mCAAmC;EACnC;;KAEG;EACH;;;;;;;;;;;;;;;;;IAiBE;;;;EAIF,UAAU;EACV;;;;;;;;KAQG;;EAEH;;;;;;IAME;EACF;;;;;;;;;KASG;;EAEH;;;;;;;;;;;;;;IAcE;IACA;;;;;;;;;;;;;;KAcC","sourcesContent":["/* \n  .form-container {\n    background-color: white;\n    border-radius: 10px;\n    padding: 30px;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    max-width: 650px;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n  } */\n  /* .password-container{\n    position: relative;\n  } */\n  \n  /* .admin-header {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 20px;\n  }\n   */\n  /* .add-user-btn {\n    background-color: #007bff;\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n   */\n  /* .add-user-btn:hover {\n    background-color: #0056b3;\n  } */\n/*   \n  .password-toggle-btn {\n    position: absolute;\n    top: 50%;\n    right: 10px;\n    transform: translateY(-50%);\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    color: #b1aeae;\n  } */\n  /* .error-message{\n    color: red;\n    font-size: 12px;\n    position: absolute;\n  } */\n  \n  /* ::placeholder{\n    color: #d1d1d1;\n  } */\n  \n  /* .form-container h2 {\n    text-align: center;\n    margin-bottom: 20px;\n  } */\n/*   \n  .form-group {\n    margin-bottom: 15px;\n    display: inline-block;\n  } */\n  \n  /* .form-group label {\n    display: block;\n    margin-bottom: 5px;\n    color: #a4a3a3;\n    font-weight: 400;\n  } */\n  \n  /* .form-group input {\n    width: 98%;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 14px;\n  } */\n  \n  /* .form-group input:focus {\n    border-color: #ffa500;\n    outline: none;\n  } */\n  /* .form-group textarea:focus {\n    border-color: #ffa500;\n    outline: none;\n  } */\n  /* textarea{\n    width: 100%;\n  }\n  input[type=\"number\"]::-webkit-inner-spin-button,\n  input[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  } */\n  \n  /* Hide spinner arrows in Firefox */\n  /* input[type=\"number\"] {\n    --moz-appearance: textfield;\n  } */\n  /* .submit-btn {\n    width: 100%;\n    padding: 10px;\n    background-color: #28a745;\n    border: none;\n    border-radius: 5px;\n    color: white;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n  }\n  .addition{\n    width: 100%;\n  }\n  .submit-btn:hover {\n    background-color: #218838;\n  }\n   */\n  \n  \n  \n  /* admin */\n  /* .admin-dashboard {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n  }\n  .admin-main {\n    display: flex;\n    flex: 1;\n  } */\n  \n  /* .admin-sidebar {\n    width: 250px;\n    background-color: #b1aeae;\n    padding: 1rem;\n    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n  }\n   */\n  /* .admin-sidebar ul {\n    list-style-type: none;\n    padding: 0;\n  }\n  \n  .admin-sidebar ul li {\n    margin-bottom: 1rem;\n    cursor: pointer;\n    font-weight: bold;\n  } */\n  \n  /* .admin-table-section {\n    flex: 1;\n    padding: 2rem;\n    overflow-x: auto;\n  }\n  \n  .admin-table-section h2 {\n    margin-bottom: 1.5rem;\n  }\n  \n  .admin-table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n   */\n    /* .admin-table th, .admin-table td {\n      padding: 12px 15px;\n      border: 1px solid #ddd;\n      text-align: left;\n    }\n    \n    .admin-table th {\n      background-color: #b1aeae;\n      color: #fff;\n    }\n    \n    .admin-table tr:nth-child(even) {\n      background-color: #f8f9fa;\n    }\n    */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
